import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import TusJsClientWrapper from "./TusJsClientWrapper";

export const ATTACHMENT_ACCEPT = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".heic",
  ".heif",
].join(",");
export const MAX_ATTACHMENT_FILES = 20;
export const MAX_ATTACHMENT_FILE_SIZE = 25 * 1024 * 1024;
export const MAX_ATTACHMENT_TOTAL_SIZE = 100 * 1024 * 1024;

export default function AttachmentUploader({
  accept = ATTACHMENT_ACCEPT,
  maxFiles = MAX_ATTACHMENT_FILES,
  maxFileSize = MAX_ATTACHMENT_FILE_SIZE,
  maxTotalSize = MAX_ATTACHMENT_TOTAL_SIZE,
  formatLabel,
  ...uploadProps
}) {
  const { t } = useTranslation();

  return (
    <TusJsClientWrapper
      {...uploadProps}
      accept={accept}
      maxFiles={maxFiles}
      maxFileSize={maxFileSize}
      maxTotalSize={maxTotalSize}
      formatLabel={formatLabel ?? t("files.attachment_formats")}
    />
  );
}

AttachmentUploader.propTypes = {
  accept: PropTypes.string,
  maxFiles: PropTypes.number,
  maxFileSize: PropTypes.number,
  maxTotalSize: PropTypes.number,
  formatLabel: PropTypes.string,
  hideFinished: PropTypes.bool,
  onSuccess: PropTypes.func,
  onUploadsChange: PropTypes.func,
  onStatusChange: PropTypes.func,
  metadata: PropTypes.object,
  asCamera: PropTypes.bool,
};
